import axios from 'axios';
import authHeader from './auth-header';

const API_URL = process.env.VUE_APP_BASE_URL + '/match-day/';

class MatchDayDataService {
    updateMatchDayByApi(data) {
        return axios.post(
            API_URL + "update/",
            {
                matchDayNumber: data.dayNumber,
                season: data.seasonYear
            },
            {headers: authHeader()}
        );
    }

    getCurrentMatchDay(){
        return axios.get(API_URL + "current", {headers: authHeader()});
    }

    getLastCalcMatchDay(season){
        return axios.post(
            API_URL + "last-calculated",
            {season: season},
            {headers: authHeader()});
    }

    getMatchDayUserPointList(data){
        return axios.get(
            API_URL + "class/day/" + data.seasonYear + "/" + data.dayNumber,
            {headers: authHeader()}
        );
    }

    getAmountOfStoredDayTipsForUser(data){
        console.log("Service: " + JSON.stringify(data));
        return axios.post(
            API_URL + "tip-amount",
            {
                matchDayNumber: data.matchDayNumber,
                subscription: data.subscription
            },
            {headers: authHeader()}
        );
    }

    getSeasonWinsClassification(subscription) {
        return axios.get(
            API_URL + "class/agg/wins/" + subscription.season.seasonYear,
            {headers: authHeader()}
        );
    }

    checkMatchDay(data) {
        return axios.post(
            API_URL + "current/ended",
            data,
            {headers: authHeader()}
        );
    }
    getMatchDayLastChangedDate(data) {
        return axios.post(
            API_URL + "last-changed-date",
            {
                day: data.dayNumber,
                season: data.seasonYear
            },
            {headers: authHeader()}
        );
    }

}

export default new MatchDayDataService();